export const ControlsSectionTestIds = {
  TOGGLE_TRUST_BUTTON: 'controls-section.toggle-trust-button',
  ADD_TITLE_HOLDER_BUTTON: 'controls-section.add-title-holder-button',
};
